import { render } from "./FragrancesAttributesFirstForm.vue?vue&type=template&id=ada65d1a&scoped=true"
import script from "./FragrancesAttributesFirstForm.vue?vue&type=script&lang=js"
export * from "./FragrancesAttributesFirstForm.vue?vue&type=script&lang=js"

import "./FragrancesAttributesFirstForm.vue?vue&type=style&index=0&id=ada65d1a&lang=scss&scoped=true"
import "./FragrancesAttributesFirstForm.vue?vue&type=style&index=1&id=ada65d1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada65d1a"]])

export default __exports__